import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { ShieldCheck, Users, ListChecks, ScrollText } from 'lucide-react';
import Layout from '../components/layout/Layout';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { AccountsTab } from '../components/console/AccountsTab';
import { PermissionsTab } from '../components/console/PermissionsTab';
import { AuditTab } from '../components/console/AuditTab';

export default function AdminConsole({ user, onLogout, theme, onThemeToggle }) {
  const [meta, setMeta] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [tab, setTab] = useState('accounts');
  const [permUserId, setPermUserId] = useState('');

  const loadAccounts = useCallback(async () => {
    const r = await axios.get('/api/console/users');
    setAccounts(r.data);
  }, []);

  useEffect(() => {
    axios.get('/api/console/meta').then(r => setMeta(r.data));
    loadAccounts();
  }, [loadAccounts]);

  const openPermissions = (id) => { setPermUserId(id); setTab('permissions'); };

  return (
    <Layout user={user} onLogout={onLogout} theme={theme} onThemeToggle={onThemeToggle}>
      <div className="space-y-6 p-4 sm:p-6" data-testid="admin-console-page">
        <div className="flex items-center gap-3">
          <div className="p-2.5 rounded-xl bg-primary/10"><ShieldCheck className="w-6 h-6 text-primary" /></div>
          <div>
            <h1 className="text-xl sm:text-2xl font-bold text-foreground">Admin Console</h1>
            <p className="text-xs sm:text-sm text-muted-foreground">Create accounts, control access and review all portal activity</p>
          </div>
        </div>
        <Tabs value={tab} onValueChange={setTab} className="space-y-4">
          <TabsList className="bg-muted/50 flex-wrap h-auto gap-1 p-1 justify-start w-full sm:w-auto">
            <TabsTrigger value="accounts" className="gap-1.5 text-xs sm:text-sm" data-testid="console-tab-accounts"><Users className="w-3.5 h-3.5" /> Accounts</TabsTrigger>
            <TabsTrigger value="permissions" className="gap-1.5 text-xs sm:text-sm" data-testid="console-tab-permissions"><ListChecks className="w-3.5 h-3.5" /> Permissions</TabsTrigger>
            <TabsTrigger value="audit" className="gap-1.5 text-xs sm:text-sm" data-testid="console-tab-audit"><ScrollText className="w-3.5 h-3.5" /> Portal Audit</TabsTrigger>
          </TabsList>
          <TabsContent value="accounts">
            {meta && <AccountsTab meta={meta} accounts={accounts} reload={loadAccounts} onPermissions={openPermissions} />}
          </TabsContent>
          <TabsContent value="permissions">
            {meta && <PermissionsTab meta={meta} accounts={accounts} reload={loadAccounts} userId={permUserId} setUserId={setPermUserId} />}
          </TabsContent>
          <TabsContent value="audit">
            <AuditTab accounts={accounts} />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
